<template>
    <div @getId="getId" class="container" style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner3.png" alt="">
        <div class="main">
            <!-- <Breadcrumb /> -->
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li>产品中心</li>
            </ul>
            <div class="content">
                <div class="menu">
                    <div @click="getNode" class="top">产品中心</div>
                    <el-tree ref="tree" :check-strictly="true" show-checkbox node-key="id" :default-checked-keys="[id]"
                        :data="treeData" :props="defaultProps" @node-click="getNode"></el-tree>
                </div>
                <div class="apply">
                    <div>
                        <div class="item" v-for="(item, index) in productList">
                            <div>
                                <img :src="item.coverImage || 'http://admin.cimomicro.com/prod-api' + item.coverImage"
                                    alt="">
                            </div>
                            <h3>{{ item.name }}</h3>
                            <p>{{ item.description }}</p>
                            <span @click="check(item)">查看产品</span>
                        </div>
                    </div>

                    <pagination v-if="productList.length>0" style="margin-top:10px" :num="total" :limit="6" @getNew="getList"></pagination>
                </div>
                <!-- <div class="apply none" v-else>暂无数据</div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { getProductTree, getProductList } from '../../api/index'
import pagination from "@/components/page/pagination.vue"
export default {
    components: {
         pagination
    },
    data() {
        return {
            active: null,
            treeData: [],
            productList: [],
            defaultProps: {
                children: 'childrens',
                label: 'name'
            },
            id: '',
            total: 0
        }
    },
    methods: {
        backPage(page){
            if(page == '-1'){
                this.$router.go(-1)
            }else{
                this.$router.push(page)
            }
        },
        getId(id) {
            this.$nextTick(() => {
                console.log(id);
            })
        },
        getNode(node) {
            this.$refs.tree.setCheckedKeys([node.id]);
            this.id = node.id ? node.id : ''
            this.getList(0)
        },
        check(item) {
            this.$router.push({ path: "/product/productDetail", query: { id: item.id } })
            document.documentElement.scrollTop = 0;
        },
        getList(val) {
            let params = {
                pageNum: val + 1,
                pageSize: 6,
                productTypeId: this.id,
            }
            getProductList(params).then(res => {
                this.productList = res.rows
                this.total = res.total
                document.documentElement.scrollTop = 0;
            })
        }
    },
    mounted() {
        this.id = this.$route.query.id
        console.log(this.id);
        getProductTree().then(res => {
            this.treeData = res.data
        })
        this.getList(0)
    },
    watch: {
        $route: {
            handler(n, o) {
                this.id = n.query.id
                this.getList(0)
                this.$refs.tree.setCheckedKeys([this.id]);
            },
            deep: true
        },
    }
}
</script>
<style lang="scss" scoped>
.top {
    background: url('../../assets/img13.png') #1f3b6d;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    cursor: pointer;
    color: #fff;
}

.active {
    background-color: #476da7;
    color: #d1d1d1;
}

.menu {
    width: 250px;
    // background-color: #fff;

    ul {
        li {
            width: 250px;
            line-height: 86px;
            border-bottom: 1px solid #cfcfcf;
            background-color: #fff;
            text-align: center;
            font-size: 18px;
            cursor: pointer;
        }

        li:last-child {
            border: none;
        }
    }
}
h3{
    font-weight: normal;
}


.container {
    background-color: #eeeeee;

    .content {
        display: flex;

        .menu {
            width: 250px;
        }

        .apply {
            flex: 1;
            margin-left: 30px;

            >div {
                overflow: hidden;
            }

            .item {
                width: 284px;
                float: left;
                margin-right: 30px;
                background-color: #fff;
                padding: 10px 20px;
                height: 350px;
                box-sizing: border-box;
                margin-bottom: 30px;
                border: 1px solid #c7c7c7;

                img {
                    width: 60%;
                    display: block;
                    margin: 0 auto;
                    height: 146px;
                }

                h3 {
                    text-align: center;
                    color: #4d4d4d;
                    font-size: 20px;
                    line-height: 40px;
                }

                p {
                    font-size: 14px;
                    overflow: hidden; //超出文本隐藏
                    text-overflow: ellipsis; ///超出部分省略号显示
                    display: -webkit-box; //弹性盒模型
                    -webkit-box-orient: vertical; //上下垂直
                    -webkit-line-clamp: 3;
                    line-height: 24px;
                    height: 72px;
                }

                span {
                    display: block;
                    width: 150px;
                    height: 40px;
                    margin: 20px auto;
                    background-color: #e5004f;
                    color: #fff;
                    line-height: 40px;
                    text-align: center;
                    cursor: pointer;
                }
            }

            .item:nth-child(3n+3) {
                margin-right: 0;
            }
        }
    }
}

.none {
    text-align: center;
    line-height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/views/center/index.vue